<script>
import { BaseIcon, SearchCustomer } from "@/components";
import { mapActions } from "vuex";
export default {
  name: "Home",
  components: {
    BaseIcon,
    SearchCustomer,
  },
  mounted() {
    this.clearPackages();
    // Send initial request to control token validity
    this.searchCustomer({ customerNo: null });
  },
  methods: {
    ...mapActions(["searchCustomer", "clearPackages"]),
  },
};
</script>

<template>
  <div>
    <div class="dashboard md-text-center">
      <base-icon name="search-user" />
      <h1 class="dashboard__title">Bir Müşteri Arayınız</h1>
    </div>
    <div class="dashboard__search-input">
      <search-customer></search-customer>
    </div>
  </div>
</template>

<style lang="scss">
.md-text-center {
  text-align: center;
  justify-content: center;
}
.dashboard {
  padding-top: 134px;
  &__title {
    margin: 20px 0;
    font-weight: 500;
  }
  &__desc {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 50px;
  }
  &__search-input {
    width: 100%;
  }
}
</style>
